export default __webpack_public_path__ + "static/media/cropped-email.ffc0e222.png";